import { render } from "./double-arrow-icon.vue?vue&type=template&id=45cfa0de"
import script from "./double-arrow-icon.vue?vue&type=script&lang=js"
export * from "./double-arrow-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__